import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/uptime/inline/list/uptime.inline.list.query.gql"
import type {
  UptimeInlineListQuery,
  UptimeInlineListQueryVariables,
} from "@/v2-backoffice-client/uptime/inline/list/__types__/uptime.inline.list.query"

type Options = QueryHookOptions<
  UptimeInlineListQuery,
  UptimeInlineListQueryVariables
>

export function useUptimeInlineListQuery(options?: Options) {
  return useQuery<UptimeInlineListQuery, UptimeInlineListQueryVariables>(
    query,
    options,
  )
}
